// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__17qyZ","actions":"GroupTable_actions__3eMj2","deleteModalFooter":"GroupTable_deleteModalFooter__JtPnC"};